import { createAction } from 'redux-actions';
export const SET_DOCUMENTS = 'REFUND/SET_DOCUMENTS';
export const SET_UPLOADED_FILES = 'REFUND/SET_UPLOADED_FILES';
export const DELETE_UPLOADED_FILE = 'REFUND/DELETE_UPLOADED_FILE';
export const setDocuments = createAction(SET_DOCUMENTS);
export const setUploadedFiles = createAction(SET_UPLOADED_FILES);
export const deleteUploadedFile = createAction(DELETE_UPLOADED_FILE);
